import styles from './Divider.module.scss';
import React from 'react';
import classNames from 'classnames';
import { DividerProps } from './types';

export const Divider: React.FC<DividerProps> = ({ className }) => {
  return <div className={classNames(styles.container, className)} />;
};
